import { type FC } from 'react';
import theme, { th } from 'style/theme';
import ParallaxImage from 'components/ParallaxImage';
import useWindowSize from 'hooks/useWindowSize';
import LAYER_0 from 'assets/img/background/sky/layer.png';
import LAYER_1 from 'assets/img/background/sky/layer1.png';
import LAYER_2 from 'assets/img/background/sky/layer2.png';
import LAYER_3 from 'assets/img/background/sky/layer3.png';
import LAYER_0_MOBILE from 'assets/img/background/sky/layer_mobile.png';
import LAYER_1_MOBILE from 'assets/img/background/sky/layer1_mobile.png';
import LAYER_2_MOBILE from 'assets/img/background/sky/layer2_mobile.png';
import LAYER_3_MOBILE from 'assets/img/background/sky/layer3_mobile.png';
import { SCREEN_SIZES } from 'style';

const PARALLAX_LAYERS = [LAYER_0, LAYER_1, LAYER_2, LAYER_3];
const MOBILE_PARALLAX_LAYERS = [
  LAYER_0_MOBILE,
  LAYER_1_MOBILE,
  LAYER_2_MOBILE,
  LAYER_3_MOBILE
];

const CustomParallaxImage: FC = () => {
  const { width: windowWidth } = useWindowSize();

  return (
    <ParallaxImage
      layers={
        windowWidth < SCREEN_SIZES.tabletPortrait
          ? MOBILE_PARALLAX_LAYERS
          : PARALLAX_LAYERS
      }
      parallaxAmount={100}
      bleedColor={th('colors.portGore')({ theme })}
      bleedColorBehind
    />
  );
};

export default CustomParallaxImage;
